import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Details.module.sass";
import Icon from "../../../components/Icon";
import Head from "./Head";
import TextInput from "../../../components/TextInput";
import {
	GetBrand,
	GetBrandStripeSecrets,
	PostBrandStripeCredentials,
	UpdateBrand,
} from "../../../Services/lib/brand";
import { UseApi } from "../../../hooks/use-api";
import GoogleAnalytic from "./GoogleAnalytic";

const Details = ({ className, onClose, data }) => {
	// Stripe
	const [publicKeyV, setPublicKeyV] = useState("");
	const [privateSecterV, setPrivateSecterV] = useState("");
	const [{ data: stripe, error: errorSecrets }, getSecrets] = UseApi({
		service: GetBrandStripeSecrets,
	});
	const [{ data: stripeData, isLoading: stripeLoading }, postStripe] = UseApi({
		service: PostBrandStripeCredentials,
		successMsg: "Success",
	});

	const saveStripeAccounts = async () => {
		const res = await postStripe({
			secretKey: privateSecterV,
			publicKey: publicKeyV,
		});
		if (res) {
			getSecrets();
			setPublicKeyV("");
			setPublicKeyV("");
		}
	};

	/// Help Desk
	const [licenseNumber, setLicenseNumber] = useState("");
	const [{ isLoading }, updateLNumber] = UseApi({
		service: UpdateBrand,
		successMsg: "Success",
	});

	const [{ data: dataBrand, isLoading: isLoadingG }, getBrand] = UseApi({
		service: GetBrand,
	});
	const onUpdateBrand = async () => {
		await updateLNumber({
			helpDeskLicenseNumber: licenseNumber,
		});
		getBrand();
	};

	// Google analytics
	const [googleAnalyticsV, setGoogleAnalytics] = useState("");
	const [{ data: updated, isLoading: brandUpdateIsLoading }, updateBrand] =
		UseApi({
			service: UpdateBrand,
			successMsg: "Success",
		});

	const [{ data: brandData, isLoading: loadingAnalytics }, fetchBrand] = UseApi(
		{
			service: GetBrand,
		}
	);

	useEffect(() => {}, []);

	const updateGoogleAnalytics = async () => {
		const body = {
			_id: brandData._id,
			siteTitle: brandData.siteTitle,
			address: brandData.address,
			brandname: brandData.brandname,
			description: brandData.description,
			domain: brandData.domain,
			taxId: brandData.taxId,
			phoneNumber: brandData.phoneNumber,
			royalty_percent: brandData.royaltyPercent,
			google_analytics_id: googleAnalyticsV,
		};
		await updateBrand(body);
		fetchBrand();
	};

	const saveClick = () => {
		switch (data.id) {
			case 0:
				updateGoogleAnalytics();
				break;
			case 1:
				onUpdateBrand();
				break;
			case 2:
				saveStripeAccounts();
				break;
			case 3:
				break;
		}
	};

	useEffect(() => {
		fetchBrand();
		getBrand();
		getSecrets();
	}, []);

	return (
		<div className={cn(styles.details, className)}>
			<button className={styles.close} onClick={onClose}>
				<Icon name="close" size="20" />
			</button>
			<Head
				className={styles.head}
				data={data}
				save={saveClick}
				loading={isLoading || stripeLoading || brandUpdateIsLoading}
				onClose={onClose}
				gotoStripe={data.id === 2 ? stripe?.secretKey : null}
			/>

			<p>{data.description || ""}</p>
			<br />

			{data.id === 0 && (
				<GoogleAnalytic
					setValue={setGoogleAnalytics}
					value={brandData?.google_analytics_id || googleAnalyticsV}
					busy={loadingAnalytics}
				/>
			)}

			{data.id === 1 && (
				<TextInput
					label={"License Number"}
					placeholder="abc.0"
					defaultValue={dataBrand?.helpDeskLicenseNumber || ""}
					onChangeInput={(e) => setLicenseNumber(e)}
				/>
			)}

			{data.id === 2 && (
				<>
					{stripe?.secretKey ? (
						<div>{stripe?.secretKey}</div>
					) : (
						<div>
							<p className={styles.space10}>
								Copy your{" "}
								<a href="https://dashboard.stripe.com/apikeys" target="_blank">
									Stripe account's
								</a>{" "}
								Publishable key and paste it here. Learn more
								<a
									href="https://docs.softr.io/integrations/etS18kJqm1fuD58KCsjC3z/stripe-checkout/iBomMEucRZtM2y6HuutYVC"
									target="_blank"
								>
									{" "}
									here
								</a>
								.
							</p>
							<TextInput
								type="text"
								placeholder="e.g. pk_Live..."
								onChangeInput={(e) => setPublicKeyV(e)}
							/>
							<br />
							<p className={styles.space10}>
								Copy your{" "}
								<a href="https://dashboard.stripe.com/apikeys" target="_blank">
									Stripe account's
								</a>{" "}
								Secret key and paste it here. Learn more
								<a
									href="https://docs.softr.io/integrations/etS18kJqm1fuD58KCsjC3z/stripe-checkout/iBomMEucRZtM2y6HuutYVC"
									target="_blank"
								>
									{" "}
									here
								</a>
								.
							</p>

							<TextInput
								onChangeInput={(e) => setPrivateSecterV(e)}
								placeholder="e.g. pk_RGib..."
								type="text"
							/>
						</div>
					)}
				</>
			)}

			{/* <PurchaseHistory className={styles.history} /> */}
		</div>
	);
};

export default Details;
